"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reinitializeBufferLayouts = void 0;
/**
 * @internal
 */
function reinitializeBufferLayouts(context, entityBuffers) {
    const layouts = entityBuffers.getAllLayouts();
    for (let i = 0, iEnd = layouts.length; i < iEnd; ++i) {
        const buffers = layouts[i].getBuffers();
        for (let j = 0, jEnd = buffers.length; j < jEnd; ++j) {
            buffers[j].initialize(context);
        }
    }
}
exports.reinitializeBufferLayouts = reinitializeBufferLayouts;
//# sourceMappingURL=reinitialize-buffer-layouts.js.map